// Mirrors pkg/billing/tax.go on the backend. The guest sees this number before the order
// exists, and the backend recomputes it on submit, so the two must agree exactly --
// including the rounding, which happens once on the total rather than per line.

export const round2 = (value) => Math.round(value * 100) / 100;

export const taxOn = (taxable, gstPercentage) => {
    if (!gstPercentage || gstPercentage <= 0 || taxable <= 0) return 0;
    return round2(taxable * gstPercentage / 100);
};

// GST is charged on what the guest actually pays, so an order-level promo discount is
// spread across the lines in proportion to their value before each line is taxed at its
// own rate. A 5% dish and an 18% one in the same order each carry their own share.
export const taxOnLines = (lines, gross, discount = 0) => {
    if (!gross || gross <= 0) return 0;

    let taxableRatio = (gross - discount) / gross;
    if (taxableRatio < 0) taxableRatio = 0;
    if (taxableRatio > 1) taxableRatio = 1;

    const total = lines.reduce((sum, line) => {
        const rate = Number(line.gst_percentage) || 0;
        if (rate <= 0) return sum;
        // Operation order mirrors pkg/billing.TaxOnLines exactly -- `* rate / 100`, not
        // `* (rate / 100)`. Both are float64, but 5/100 is not exactly representable, so the
        // two groupings land either side of a half-paisa and the guest's quote drifts a
        // paisa from what the backend stores.
        return sum + (Number(line.amount) || 0) * taxableRatio * rate / 100;
    }, 0);

    return round2(total);
};
